import React from 'react';
import Chip from '../shared/Chip';

/*
 * Upload state on the shared Chip: Available is Success and Failed is Error.
 * Uploading is the Standard grey chip carrying the percentage, not the
 * in-progress Processing variant — a Library design decision (DES-24). There
 * is no progress bar.
 *
 * A status this map doesn't know (one the API adds later) shows neutrally, as
 * a Standard chip with its own name, never as a success it may not be.
 */
const STATUS_CHIP = {
  available: { label: 'Available', variant: 'success' },
  failed: { label: 'Failed', variant: 'error' },
  uploading: { label: 'Uploading', variant: 'standard' },
};

function unknownStatus(status) {
  const text = String(status || 'unknown').replace(/_/g, ' ');
  return { label: text.charAt(0).toUpperCase() + text.slice(1), variant: 'standard' };
}

function LibraryStatusChip({ doc }) {
  const meta = STATUS_CHIP[doc.status] || unknownStatus(doc.status);
  const progress = doc.status === 'uploading' ? ` ${Math.round(doc.progress || 0)}%` : '';
  return <Chip variant={meta.variant}>{`${meta.label}${progress}`}</Chip>;
}

export default LibraryStatusChip;
